import { render } from "./LiniiDocumenteView.vue?vue&type=template&id=1a501925&scoped=true&ts=true"
import script from "./LiniiDocumenteView.vue?vue&type=script&lang=ts"
export * from "./LiniiDocumenteView.vue?vue&type=script&lang=ts"

import "./LiniiDocumenteView.vue?vue&type=style&index=0&id=1a501925&scoped=true&lang=css"
import "./LiniiDocumenteView.vue?vue&type=style&index=1&id=1a501925&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a501925"]])

export default __exports__